"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchNotePayloadDtoCategoryEnum = exports.PatchNotePayloadDtoStateEnum = void 0;
exports.PatchNotePayloadDtoStateEnum = {
    Active: 'active',
    Inactive: 'inactive'
};
exports.PatchNotePayloadDtoCategoryEnum = {
    General: 'general',
    Delayed: 'delayed',
    FollowUp: 'follow_up',
    Production: 'production',
    SendOut: 'send_out',
    ReportWriting: 'report_writing'
};
